import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const QuickTaleWarningModal = ({
  open,
  onClose,
  onSaveAsDraft,
  onFinishQuickTale,
  type = 'missing', // 'missing' or 'draft'
  missingFields = [],
}) => {
  const isMissingFieldsMode = type === 'missing';
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="warning-dialog-title"
      aria-describedby="warning-dialog-description"
    >
      <DialogTitle id="warning-dialog-title">
        {isMissingFieldsMode 
          ? "Your QuickTale Needs:" 
          : "Save your QuickTale as a draft?"}
      </DialogTitle>
      <DialogContent>
        {isMissingFieldsMode ? (
          <List sx={{ listStyleType: 'disc', pl: 2 }}>
            {missingFields.map((field, index) => (
              <ListItem 
                key={index} 
                sx={{ display: 'list-item', padding: '4px 0' }}
              >
                <ListItemText primary={field} />
              </ListItem>
            ))}
          </List>
        ) : (
          <DialogContentText id="warning-dialog-description">
            {/* Empty for draft mode - title contains the message */}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        {isMissingFieldsMode ? (
          <>
            <Button onClick={onClose} color="primary">
              Cancel
            </Button>
            <Button onClick={onSaveAsDraft} color="primary" autoFocus>
              Save As Draft
            </Button>
          </>
        ) : (
          <>
            <Button onClick={onClose} color="primary">
              Cancel
            </Button>
            <Button onClick={onSaveAsDraft} color="primary">
              Save As Draft
            </Button>
            <Button onClick={onFinishQuickTale} color="primary" autoFocus>
              Finish QuickTale
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default QuickTaleWarningModal;
